import React from "react";
import "react-loading-skeleton/dist/skeleton.css";

const TableLoading = ({ rows = 5, Columns = 3 }) => {
  return (
    <div className="h-full flex flex-col bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
      <div className="animate-pulse flex flex-col h-full">
        <div className="flex-shrink-0 flex flex-col sm:flex-row sm:items-center justify-between px-6 py-5 gap-4 bg-gradient-to-r from-gray-50 to-white border-b border-gray-100">
          <div className="flex-1">
            <div className="h-6 bg-gray-200 rounded-lg w-1/4"></div>
          </div>
        </div>
        <div className="flex-1 min-h-0 overflow-hidden bg-white">
          <div className="h-full overflow-x-auto">
            <div className="min-w-full align-middle">
              <table className="min-w-full">
                <thead className="bg-gray-50/50 border-b border-gray-200">
                  <tr>
                    {Array.from({ length: Columns }).map((_, index) => (
                      <th key={index} className="px-6 py-4">
                        <div className="h-4 bg-gray-200 rounded w-2/3" />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {Array.from({ length: rows }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                      {Array.from({ length: Columns }).map((_, colIndex) => (
                        <td key={colIndex} className="px-6 py-4">
                          {colIndex === 0 ? (
                            <div className="flex items-center gap-3">
                              <div className="h-10 w-10 rounded-full bg-gray-200" />
                              <div className="h-4 bg-gray-200 rounded w-24" />
                            </div>
                          ) : (
                            <div className="h-4 bg-gray-200 rounded w-20" />
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableLoading;
